<template>
  <div
    v-loading="loading"
    class="wechat-lead-all-lead"
  >
    <div class="table-search-header">
      <mk-select
        v-model="queryParams.gender"
        placeholder="性别"
        width="120"
        class="input-common"
      >
        <mk-option
          v-for="item in sexOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </mk-option>
      </mk-select>
      <mk-cascader
        v-model="queryParams.area"
        :options="areaOptions"
        :props="props"
        collapse-tags
        filterable
        clearable
        width="240"
        placeholder="地区（多选）"
        class="input-common input-cascader"
      ></mk-cascader>
      <mk-select
        v-model="queryParams.person"
        multiple
        collapse-tags
        filterable
        clearable
        placeholder="跟进人"
        width="220"
        class="input-common"
      >
        <mk-option
          v-for="item in ownerOptions"
          :key="item._id"
          :label="item.name"
          :value="item._id"
        >
        </mk-option>
      </mk-select>
      <!-- <mk-select
        v-model="queryParams.tags"
        multiple
        collapse-tags
        filterable
        clearable
        placeholder="行为标签（多选）"
        width="220"
        class="input-common"
      >
        <mk-option
          v-for="item in tagOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </mk-option>
      </mk-select> -->
      <mk-cascader
        v-model="queryParams.scene"
        :options="sceneOptions"
        size="small"
        :props="sceneProps"
        collapse-tags
        filterable
        clearable
        width="240"
        placeholder="来源（多选）"
        class="input-common input-cascader"
      />
      <!-- <mk-select
        v-model="queryParams.scene"
        multiple
        collapse-tags
        filterable
        clearable
        placeholder="来源（多选）"
        width="220"
        class="input-common"
      >
        <mk-option
          v-for="item in sceneOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </mk-option>
      </mk-select> -->
      <mk-select
        v-model="queryParams.isSyncWPContact"
        placeholder="是否关联"
        width="100"
        class="input-common"
      >
        <mk-option
          v-for="item in syncWPContactOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </mk-option>
      </mk-select>
      <div
        v-show="showMoreSearchCon"
        class="special-tag-search"
      >
        <mk-select
          v-model="queryParams.tags"
          multiple
          filterable
          clearable
          placeholder="行为标签（多选）"
          width="240"
          :style="{height: selectedShowHeight}"
          @change="onTagsSelect"
        >
          <mk-option
            v-for="item in tagOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value + '//' + item.label"
          >
          </mk-option>
        </mk-select>
        <div
          v-if="selectedShowData.length > 0"
          ref="selectedShow"
          class="selected-tags-show"
        >
          <div
            v-for="(item, index) in selectedShowData"
            :key="index"
            class="selected-tags-item"
          >
            <span class="selected-tag-name">{{ item.label }}</span>
            <mk-input
              v-model="item.tagScore"
              height="20"
              width="50"
              class="score-input"
              type="number"
              :min="1"
              @blur="onScoreBlur(item.tagScore, index)"
            ></mk-input> <i
              class="el-tag__close el-icon-close icon-close"
              @click="deleteSelectedTag(index)"
            ></i>
          </div>
        </div>
      </div>
      <mk-select
        v-show="showMoreSearchCon"
        v-model="queryParams.materialId"
        filterable
        clearable
        remote
        :remote-method="querySearchAsync"
        placeholder="用户访问了某个营销资料"
        width="220"
        class="input-common"
        :loading="isFetchData"
      >
        <mk-option
          v-for="item in materialOptions"
          :key="item._id"
          :label="item.title"
          :value="item._id"
        >
        </mk-option>
      </mk-select>
      <mk-select
        v-show="showMoreSearchCon"
        v-model="queryParams.planId"
        filterable
        clearable
        remote
        :remote-method="querySearchPlanAsync"
        placeholder="用户参与了某项营销计划"
        width="220"
        class="input-common"
        :loading="isFetchData"
      >
        <mk-option
          v-for="item in planOptions"
          :key="item._id"
          :label="item.name"
          :value="item._id"
        >
        </mk-option>
      </mk-select>
      <div
        v-show="showMoreSearchCon"
        class="input-common interaction-input"
      >
        用户有过<mk-input-number
          v-model="queryParams.clueUATotal"
          :min="1"
          :max="999"
          controls-position="right"
          width="100"
          class="interaction-count"
        ></mk-input-number>次以上互动行为
      </div>
      <div class="search-button">
        <mk-button-biz
          type="primary"
          :icon="showMoreSearchCon ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          @click="showMoreSearchCon = !showMoreSearchCon"
        >
          {{ showMoreSearchCon ? '收起' : '展开' }}
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          icon="el-icon-search"
          @click="searchByCondition(1)"
        >
          搜索
        </mk-button-biz>
        <mk-button-biz @click="resetSearchData">
          重置
        </mk-button-biz>
        <mk-switch
          v-model="queryParams.isSale"
          active-color="#009CFF"
          class="switch-search"
          active-text="列表展示员工"
          @change="searchByCondition(1)"
        >
        </mk-switch>
      </div>
    </div>
    <div class="table-search-body">
      <!-- :default-sort="{prop: 'clueUA', order: 'descending'}" -->
      <mk-table
        v-if="tableMaxHeight"
        :max-height="tableMaxHeight"
        :data="tableData"
        style="width: 100%;"
        @sort-change="sortChange"
      >
        <mk-table-column
          label="头像"
          width="52px"
          fixed
        >
          <template v-slot="scope">
            <div class="avatar-url">
              <img :src="scope.row.avatarUrl">
            </div>
          </template>
        </mk-table-column>
        <mk-table-column
          label="昵称"
          fixed
          show-overflow-tooltip
        >
          <template v-slot="scope">
            <div
              v-if="scope.row.isSale"
              class="is-sale"
            >
              员工
            </div>
            <a
              href="javascript: void(0)"
              class="a-click"
              @click="openDialog(scope.row)"
            >{{ scope.row.nickName }}
              <span
                v-if="scope.row.isSyncWPContact"
                class="is-connect-work-phone"
              >
                <mk-popover
                  placement="right-start"
                  trigger="hover"
                  content="已关联工作手机微信"
                >
                  <mk-iconfont
                    slot="reference"
                    class="el-icon-right"
                    icon-class="gzsj"
                  ></mk-iconfont>
                </mk-popover>
              </span>
            </a>
          </template>
        </mk-table-column>
        <mk-table-column
          label="性别"
          width="60"
        >
          <template v-slot="scope">
            {{ scope.row.gender === 0 ? '未知' : scope.row.gender === 1 ? '男' : '女' }}
          </template>
        </mk-table-column>
        <mk-table-column
          label="地区"
          width="160"
        >
          <template v-slot="scope">
            {{ scope.row.country }}
            <template v-if="scope.row.province">
              /
            </template>
            {{ scope.row.province }}
            <template v-if="scope.row.city">
              /
            </template>{{ scope.row.city }}
          </template>
        </mk-table-column>
        <mk-table-column
          prop="fromSceneText"
          label="来源"
          width="120"
          show-overflow-tooltip
        >
        </mk-table-column>
        <mk-table-column
          label="跟进人"
          width="150"
          show-overflow-tooltip
        >
          <template v-slot="scope">
            <span
              v-for="(item,index) in scope.row.showNames"
              :key="index"
            >
              {{ item }}<template v-if="index < scope.row.showNames.length - 1">、</template>
            </span>
            <mk-popover
              placement="right-start"
              trigger="hover"
            >
              <span slot="reference">
                <span
                  v-if="scope.row.userCount > 3"
                  class="all-user-count"
                >
                  等{{ scope.row.userCount }}人
                </span>
              </span>
              <div class="all-lead-popover-owner-list">
                <div
                  v-for="(item, index) in scope.row.userNames"
                  :key="index"
                  class="owner-list-item"
                >
                  {{ item }}
                </div>
              </div>
            </mk-popover>
          </template>
        </mk-table-column>
        <mk-table-column
          label="互动次数"
          width="120"
          sortable
        >
          <template v-slot="scope">
            <mk-popover
              placement="right-start"
              trigger="hover"
            >
              <span slot="reference">{{ scope.row.count }}</span>
              <div>
                <div
                  v-for="(item, index) in scope.row.clueUA"
                  :key="index"
                >
                  <div v-if="item.platform === 'WPN'">
                    访问H5：{{ item.visitCount }}次
                  </div>
                  <div v-else-if="item.platform === 'MINI'">
                    访问小程序：{{ item.visitCount }}次
                  </div>
                </div>
              </div>
            </mk-popover>
          </template>
        </mk-table-column>
        <mk-table-column
          label="标签评分"
          width="120"
          prop="tagScoreTotal"
          sortable
        >
        </mk-table-column>
        <mk-table-column
          label="最近访问时间"
          width="150"
          sortable
        >
          <template v-slot="scope">
            {{ scope.row.lastVisitTime.slice(0,16) }}
          </template>
        </mk-table-column>
        <mk-table-column
          prop="date"
          label="行为标签"
          width="420"
        >
          <template v-slot="scope">
            <mk-popover
              placement="right-start"
              trigger="hover"
              :disabled="scope.row.countTags <= 3"
            >
              <div
                slot="reference"
                class="tag-common"
              >
                <div class="tag-container">
                  <!-- <span
                    v-for="(item, index) in scope.row.tagScoreShow"
                    :key="index"
                    class="el-tag-span"
                  > -->
                  <mk-tag
                    v-for="(item, index) in scope.row.tagScoreShow"
                    :key="index"
                    :title="item.tag.name + '(' + item.tagScore +')'"
                  >
                    {{ item.tag.name }}({{ item.tagScore > 999 ? '999+' : item.tagScore }})
                  </mk-tag>
                  <!-- </span> -->
                </div>
                <span
                  v-if="scope.row.countTags > 3"
                  class="tag-overflow-mention"
                >等{{ scope.row.countTags }}个标签</span>
              </div>
              <div class="all-lead-popover-tags">
                <mk-tag
                  v-for="(item, index) in scope.row.tagScore"
                  :key="index"
                  class="tag-item"
                >
                  {{ item.tag.name }}({{ item.tagScore > 999 ? '999+' : item.tagScore }})
                </mk-tag>
              </div>
            </mk-popover>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div class="pagination">
      <mk-pagination
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
    <friend-details
      v-if="visible"
      :friend-id="friendId"
      :agent-id="activeTab"
      :visible.sync="visible"
      :friend-data="friendData"
    ></friend-details>
  </div>
</template>

<script>
import FriendDetails from '../components/friend-details'
export default {
  name: 'WeChatLeadAllLead',
  components: {
    FriendDetails
  },
  data () {
    return {
      // 性别选项
      sexOptions: [
        { label: '未知', value: 0 },
        { label: '男', value: 1 },
        { label: '女', value: 2 }
      ],
      // 跟进人下拉筛选
      ownerOptions: [],
      // 场景下拉
      sceneOptions: [],
      // 地区下拉
      areaOptions: [],
      // 标签下拉
      tagOptions: [],
      // 标签框的高度
      selectedShowHeight: '32px',
      // 标签多选之后展示的数据
      selectedShowData: [],
      // 是否关联下拉
      syncWPContactOptions: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      // 级联选择器props
      props: {
        multiple: true,
        value: 'name',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      sceneProps: {
        multiple: true,
        value: '_id',
        label: 'name',
        children: 'children'
      },
      // table数据
      tableData: [],
      // 当期那页码
      page: 1,
      // table数据总数
      total: 0,
      // 弹窗是否可见
      visible: false,
      // 是否正在加载
      loading: false,
      // 当前查看的好友的id
      friendId: '',
      // 当前微信号
      agentId: '',
      // 好友详情
      friendData: {
        wpWxContact: {},
        message: null,
        attributeTag: [],
        actionTag: []
      },
      // 当前选择的tab
      activeTab: '',
      // 查询的条件
      queryParams: {
        // 性别
        gender: '',
        // 地区
        area: [],
        // 跟进人
        person: [],
        // 来源
        scene: [],
        // 是否关联
        isSyncWPContact: '',
        // 资料id
        materialId: '',
        // 计划id
        planId: '',
        // 互动总数大于
        clueUATotal: 1,
        // 标签
        tags: [],
        // 是否是销售
        isSale: true
      },
      // 用户名的map
      userNameMap: {},
      // 更多查询条件是否展示
      showMoreSearchCon: false,
      // 远程搜索资料的值
      materialOptions: [],
      // 远程搜索计划的值
      planOptions: [],
      // 是否正在远程搜索flag
      isFetchData: false,
      tableMaxHeight: 0,
      sortField: '',
      isAsc: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.table-search-body', this)
    })
    this.getAllDataAndSearch()
    this.staticDataGet()
  },
  methods: {
    // 互动次数排序
    sortChange ({ column, order }) {
      let label = column.label
      let sortField = ''
      if (label === '互动次数') {
        sortField = 'clueUATotal'
      } else if (label === '标签评分') {
        sortField = 'tagScoreTotal'
      } else if (label === '最近访问时间') {
        sortField = 'lastVisitTime'
      }
      this.sortField = sortField
      let queryParams = this._.cloneDeep(this.queryParams)
      for (let key in queryParams) {
        if (key === '' || queryParams[key].length === 0) {
          delete queryParams[key]
        }
      }
      if (queryParams.scene) {
        let scene = ''
        let len = queryParams.scene.length
        queryParams.scene.forEach((item, index) => {
          if (index < len - 1) {
            scene += item[0] + '/' + item[1] + '-'
          } else {
            scene += item[0] + '/' + item[1]
          }
        })
        queryParams.scene = scene
      }
      if (queryParams.person) {
        queryParams.person = queryParams.person.join(',')
      }
      if (queryParams.area) {
        let arr = []
        queryParams.area.forEach(item => {
          arr.push(item.join('/'))
        })
        queryParams.area = arr.join('-')
      }
      if (queryParams.tags) {
        let arr = []
        this.selectedShowData.forEach(item => {
          arr.push({
            tagScore: parseInt(item.tagScore),
            tid: item.tid
          })
        })
        queryParams.tags = arr
      }
      this.page = 1
      if (order) {
        this.isAsc = order !== 'descending'
        this.wxclueAllCluePost({
          page: 1,
          pageSize: 10,
          ...queryParams,
          isAsc: order !== 'descending',
          sortField: sortField
        })
      } else {
        this.sortField = ''
        this.isAsc = null
        this.wxclueAllCluePost({
          page: 1,
          pageSize: 10,
          ...queryParams
        })
      }
    },
    // tabs点击切换时
    handleTabsClick () {
      this.searchByCondition(1)
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.searchByCondition(val)
    },
    // 选择tag时
    onTagsSelect (val) {
      let data = []
      val.forEach(item => {
        data.push({
          tagScore: 1,
          tid: item.split('//')[0],
          label: item.split('//')[1]
        })
      })
      this.selectedShowData = data
      this.countHeight()
    },
    // 失去焦点时候验证输入
    onScoreBlur (val, index) {
      if (val < 1) {
        this.selectedShowData[index].tagScore = 1
      }
      if (val > 999) {
        this.selectedShowData[index].tagScore = 999
      }
    },
    // 删除已选择标签
    deleteSelectedTag (index) {
      this.selectedShowData.splice(index, 1)
      this.queryParams.tags.splice(index, 1)
      this.countHeight()
    },
    // 计算自定义展示标签的框的高度
    countHeight () {
      let itemCount = this.selectedShowData.length
      // 每个item高26px 并且容器的padding为10px, 搜索框的福鼎高度24px
      this.selectedShowHeight =
        itemCount > 0 ? itemCount * 26 + 34 + 'px' : '32px'
    },
    // 搜索营销资料
    async querySearchAsync (str) {
      if (!str) {
        return
      }
      this.isFetchData = true
      let res = await this.wxclueAllMaterialGet(str)
      this.isFetchData = false
      if (res.success) {
        this.materialOptions = res.data
      }
    },
    // 搜索营销计划
    async querySearchPlanAsync (str) {
      if (!str) {
        return
      }
      this.isFetchData = true
      let res = await this.wxclueAllPlanGet(str)
      this.isFetchData = false
      if (res.success) {
        this.planOptions = res.data
      }
    },
    // 条件查询所有营销资料
    async wxclueAllMaterialGet (title) {
      let res = await BIZAPIS.WxclueApi.wxclueAllMaterialGet({
        title
      })
      return res
    },
    // 条件查询所有营销计划
    async wxclueAllPlanGet (name) {
      let res = await BIZAPIS.WxclueApi.wxclueAllPlanGet({
        name
      })
      return res
    },
    // 搜索
    searchByCondition (page) {
      if (!page) {
        page = 1
      }
      let queryParams = this._.cloneDeep(this.queryParams)
      for (let key in queryParams) {
        if (key === '' || queryParams[key].length === 0) {
          delete queryParams[key]
        }
      }
      if (queryParams.scene) {
        // '2012/1-2020/2'
        let scene = ''
        let len = queryParams.scene.length
        queryParams.scene.forEach((item, index) => {
          if (index < len - 1) {
            scene += item[0] + '/' + item[1] + '-'
          } else {
            scene += item[0] + '/' + item[1]
          }
        })
        queryParams.scene = scene
      }
      if (queryParams.person) {
        queryParams.person = queryParams.person.join(',')
      }
      if (queryParams.area) {
        let arr = []
        queryParams.area.forEach(item => {
          arr.push(item.join('/'))
        })
        queryParams.area = arr.join('-')
      }
      if (queryParams.tags) {
        let arr = []
        this.selectedShowData.forEach(item => {
          arr.push({
            tagScore: parseInt(item.tagScore),
            tid: item.tid
          })
        })
        queryParams.tags = arr
      }
      let params = {
        page: page,
        pageSize: 10,
        ...queryParams
      }
      this.wxclueAllCluePost(params)
    },
    // 重置
    resetSearchData () {
      this.queryParams = {
        gender: '',
        area: [],
        scene: [],
        person: [],
        isSyncWPContact: '',
        materialId: '',
        planId: '',
        clueUATotal: 1,
        tags: [],
        isSale: true
      }
      this.selectedShowData = []
      this.countHeight()
      this.searchByCondition(1)
    },
    // 打开弹框
    openDialog (data) {
      this.visible = false
      this.wxclueWxclueWxcontactGet(data.unionId, data.userId)
      this.friendData = data
    },
    // 查询微信线索信息-详细信息
    async wxclueWxclueWxcontactGet (unionId, userId) {
      this.loading = true
      let res = await BIZAPIS.WxclueApi.wxclueWxclueWxcontactGet({
        unionId,
        userId
      })
      this.loading = false
      if (res.success) {
        this.friendData = {
          ...this.friendData,
          m7WxNo: res.data.m7WxNo,
          m7Uid: res.data.m7Uid
        }
        this.visible = true
      }
    },
    // 获取列表
    async wxclueAllCluePost (data) {
      this.loading = true
      let metas = {
        sortField: this.sortField,
        isAsc: this.isAsc
      }
      if (!this.sortField) {
        delete metas.sortField
        delete metas.isAsc
      }
      let res = await CLUEAPIS.ClueApi.clueMkListPost({ ...data, ...metas })
      this.loading = false
      if (res.success) {
        this.tableData = res.data.data
        this.tableData.forEach(item => {
          item.count = 0
          item.fromSceneText = ''
          item.userNames = []
          if (item.clueUA) {
            item.clueUA.forEach(innerItem => {
              item.count += innerItem.visitCount
            })
          }
          this.sceneOptions.forEach(scene => {
            if (scene._id === item.firstScene) {
              item.fromSceneText += scene.name + '/'

              if (scene.children instanceof Array) {
                scene.children.forEach(itemC => {
                  if (itemC._id === item.secondScene) {
                    item.fromSceneText += itemC.name
                  }
                })
              } else {
                item.fromSceneText = scene.name
              }
            }
          })
          item.userIds.forEach(innerItem => {
            let name = this.userNameMap[innerItem]
              ? this.userNameMap[innerItem]
              : ''
            item.userNames.push(name)
          })
          // 只显示前三个跟进人
          item.showNames = item.userNames.slice(0, 3)
          // 防止后端控制时候又返回null
          item.tagScore = item.tagScore ? item.tagScore : []
          item.tagScoreShow = item.tagScore.slice(0, 3)
        })
        // this.page = res.data.page
        this.total = res.data.total
      }
    },
    staticDataGet () {
      this.wxclueEventGet()
      this.tagEnableGet()
      this.wxclueAreaGet()
    },
    // 查询用户动作
    async wxclueEventGet () {
      let res = await BIZAPIS.WxclueApi.wxclueEventGet()
    },
    // 查询行为标签
    async tagEnableGet () {
      let res = await BIZAPIS.TagApi.tagEnableGet()
      if (res.success) {
        res.data.forEach(item => {
          if (item.children.length > 0) {
            item.children.forEach(tag => {
              this.tagOptions.push({
                label: tag.name,
                value: tag.id
              })
            })
          }
        })
      }
    },
    // 获取场景下拉列表数据和所有销售数据，并在获取之后调用接口
    async getAllDataAndSearch () {
      let res = await Promise.all([
        this.wxclueSceneGet(),
        this.getAllUserList()
      ])
      if (res[0].success) {
        let { data } = res[0]
        data.forEach(item => {
          if (item.children.length === 0) {
            delete item.children
          }
          this.sceneOptions.push(item)
        })
      }
      if (res[1]) {
        let data = this._.cloneDeep(res[1])
        data.forEach(item => {
          this.userNameMap[item._id] = item.name
        })
        this.ownerOptions = data
      }
      this.searchByCondition(1)
    },
    // 查询来源
    async wxclueSceneGet () {
      this.loading = true
      let res = await CLUEAPIS.ClueApi.clueMkSceneGet()
      return res
    },
    // 查询跟进人列表数据
    async getAllUserList () {
      let user = await this.$DexiePlguin.getAllUser()
      return user
    },
    // 查询微信线索地区列表
    async wxclueAreaGet () {
      let res = await BIZAPIS.WxclueApi.wxclueAreaGet()
      if (res.success) {
        this.areaOptions = res.data.area
      }
    },
    platformFormat (platform) {
      switch (platform) {
        case 'WPN':
          return 'H5推广'
        case 'mini':
          return '小程序'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-lead-all-lead {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 20px 20px;
  box-sizing: border-box;

  /deep/ .mk-cascader {
    line-height: 32px;

    & .el-input {
      .el-input__inner {
        height: 32px !important;
        font-size: 13px;
      }

      .el-input__suffix,
      .el-icon-arrow-down {
        height: 32px;
        line-height: 32px;
      }
    }
  }

  .a-click {
    text-decoration: none;
    color: #009cff;
  }

  .wx-number {
    display: flex;
    align-items: center;
  }

  .input-common {
    margin: 10px 8px 0 0;
    height: 32px;

    /deep/ .el-tag--info {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 120px;
    }
  }

  //行为标签搜索
  .special-tag-search {
    position: relative;
    margin: 10px 8px 0 0;

    .mk-select {
      min-height: 32px;

      /deep/ .el-select__tags {
        height: 100%;
      }

      /deep/ .el-select__input {
        position: absolute;
        bottom: 4px;
        height: 22px;
        width: 100% !important;
      }

      /deep/ .el-select__tags > span {
        display: none;
      }

      /deep/ .el-input {
        height: 100%;
        min-height: 32px;

        input {
          height: 100% !important;
          min-height: 32px;
        }
      }
    }

    .selected-tags-show {
      position: absolute;
      z-index: 99;
      top: 0;
      left: 0;
      padding: 5px 0 5px 6px;

      .selected-tags-item {
        height: 24px;
        margin-top: 2px;
        padding: 0 8px;
        line-height: 22px;
        font-size: 12px;
        box-sizing: border-box;
        background-color: #f4f4f5;
        border: 1px solid #e9e9eb;
        color: #909399;
        border-radius: 4px;

        .selected-tag-name {
          display: inline-block;
          width: 110px;
        }

        .score-input {
          /deep/ input {
            padding: 0;
          }
        }

        .icon-close {
          border-radius: 50%;
          text-align: center;
          position: relative;
          cursor: pointer;
          font-size: 12px;
          height: 16px;
          width: 16px;
          line-height: 16px;
          vertical-align: middle;
          top: -1px;
          right: -5px;
          transform: scale(0.8);
          background-color: #c0c4cc;

          &:hover {
            color: #fff;
            background-color: #909399;
          }

          &::before {
            display: block;
            transform: translate(0, 0.5px);
          }
        }
      }
    }
  }

  .interaction-input {
    font-size: 14px;

    .interaction-count {
      margin: 0 5px;
    }
  }

  .input-cascader {
    line-height: 1.15;
  }

  .table-search-header {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .search-button {
      // margin-left: 20px;
      margin-top: 10px;
    }

    .switch-search {
      margin-left: 10px;
    }
  }

  .table-search-body {
    height: 100%;
    margin-top: 10px;

    &::-webkit-scrollbar {
      display: none;
    }

    .tag-common {
      display: flex;
      align-items: center;
    }

    .tag-container {
      display: flex;

      .el-tag {
        max-width: 100px;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 22px;
        line-height: 22px;
        border-radius: 2px;
        padding: 0 8px;
        background: rgba(235, 239, 244, 1);
        color: #6b7b88;
        border: none;
      }

      .el-tag + .el-tag {
        margin-left: 10px;
      }
    }

    .tag-overflow-mention {
      font-size: 13px;
      margin-left: 10px;
    }

    .is-sale {
      margin-right: 8px;
      display: inline-block;
      font-size: 12px;
      width: 30px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 2px;
      border: 1px solid rgba(0, 156, 255, 1);
      color: #009cff;
    }
  }

  .pagination {
    display: flex;
    // margin-bottom: 20px;
    justify-content: flex-end;
  }

  // // 覆盖 element tabs样式
  // /deep/ .el-tabs__header .el-tabs__nav-wrap {
  //   padding-left: 0;
  // }

  .icon-mk-gzsj {
    color: #009cff;
  }

  /deep/ .el-cascader__tags {
    display: flex;
    flex-wrap: nowrap;
  }

  .el-cascader {
    /deep/ .el-input__suffix {
      top: -2px;
    }

    /deep/ .el-icon-arrow-down {
      line-height: 40px;
    }

    /deep/ .is-reverse {
      line-height: 29px;
    }
  }

  /deep/ .el-cascader__search-input {
    flex: 1;
  }

  .all-user-count {
    display: inline-block;
    white-space: nowrap;
  }

  // /deep/ .el-tabs__item {
  //   margin-right: 20px;
  // }

  .avatar-url {
    width: 26px;
    height: 26px;

    img {
      width: 100%;
      border-radius: 2px;
    }
  }

  /deep/ .caret-wrapper {
    height: 21px;

    .ascending {
      top: -1px;
    }

    .descending {
      bottom: -1px;
    }
  }
}
</style>

<style lang="scss">
.all-lead-popover-owner-list {
  max-height: 150px;
  overflow: auto;

  .owner-list-item {
    line-height: 30px;
  }
}

.all-lead-popover-tags {
  max-width: 200px;

  .tag-item {
    margin: 5px 0 0 5px;
    height: 22px;
    line-height: 22px;
    border-radius: 2px;
    padding: 0 8px;
    background: rgba(235, 239, 244, 1);
    color: #6b7b88;
    border: none;
  }
}
</style>
